import { Injectable } from '@angular/core';
import { ParamMap, Params } from '@angular/router';
import { Store } from '@ngrx/store';
import { ReportType } from '../reports/models/report-type.model';
import {
  clearCurrentReport,
  fetchDashboard,
  fetchExpandedView,
  fetchReport,
  IFetchDashboardPayload,
  registerHomeMetricsPolling,
  resetReportsData,
  unregisterHomeMetricsPolling,
  updateCurrentReportFilterValues,
} from './report-data.actions';
import {
  HOME_METRICS_POLLING_INTERVAL,
  ReportExpandedViewTypesEnum,
} from './report-data.data';

@Injectable()
export class ReportDataDispatcher {
  constructor(private _store: Store<any>) {}

  fetchDashboard(dashboardProperties?: IFetchDashboardPayload) {
    this._store.dispatch(fetchDashboard(dashboardProperties));
  }

  resetReportsData() {
    this._store.dispatch(resetReportsData());
  }

  updateCurrentReportFilterValues(reportFilterValues: Params) {
    this._store.dispatch(updateCurrentReportFilterValues(reportFilterValues));
  }

  fetchReport(reportType: ReportType, queryParams: ParamMap) {
    this._store.dispatch(fetchReport(reportType, queryParams));
  }

  clearCurrentReport() {
    this._store.dispatch(clearCurrentReport());
  }

  registerHomeMetricsPolling(interval: number = HOME_METRICS_POLLING_INTERVAL) {
    this._store.dispatch(registerHomeMetricsPolling(interval));
  }

  unregisterHomeMetricsPolling() {
    this._store.dispatch(unregisterHomeMetricsPolling());
  }

  fetchExpandedView(
    types: ReportExpandedViewTypesEnum[],
    currencyCode: string,
    topItemsLimit?: number
  ) {
    this._store.dispatch(fetchExpandedView(types, currencyCode, topItemsLimit));
  }
}
